export const COLORS = {
  brandTeal: '#40E0D0',
  coral: '#FF6F61',
  charcoal: '#111111',
  cardBg: '#181818',
  offWhite: '#F5F5F5',
  muted: '#A0A0A0',
} as const;

export const BROAD_CATEGORIES = [
  'Conflict',
  'Education',
  'Environment',
  'Health',
  'Housing',
  'Identity',
  'Justice',
  'Media',
  'Migration',
  'Work',
] as const;

export type BroadCategory = typeof BROAD_CATEGORIES[number];

export const INTERESTS = BROAD_CATEGORIES;

export type Interest = typeof INTERESTS[number];

export const LEGACY_INTEREST_MAPPING: Record<string, BroadCategory> = {
  'Climate justice': 'Environment',
  'Climate': 'Environment',
  'Indigenous rights': 'Identity',
  'Indigenous': 'Identity',
  'Policing & prisons': 'Justice',
  'Borders & migration': 'Migration',
  'Workers\' rights': 'Work',
  'Queer & trans rights': 'Identity',
  'Digital freedom': 'Media',
  'Housing & gentrification': 'Housing',
  'Reproductive rights': 'Health',
  'Art & censorship': 'Media',
  'Culture': 'Identity',
  'Mental health': 'Health',
  'War': 'Conflict',
  'Work & Economy': 'Work',
  'Economy': 'Work',
};

export const PLACEHOLDER_IMAGE = '/placeholder-civicbeat.svg';
